import { render, staticRenderFns } from "./trafficComponents.vue?vue&type=template&id=7e042477&scoped=true"
import script from "./trafficComponents.vue?vue&type=script&lang=js"
export * from "./trafficComponents.vue?vue&type=script&lang=js"
import style0 from "./trafficComponents.vue?vue&type=style&index=0&id=7e042477&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e042477",
  null
  
)

export default component.exports